import { Component, OnInit } from '@angular/core';
import { Operation } from '../../../models/permissions/operation.model';
import { FormControl } from '@angular/forms';
import { OperationsService } from '../../../services/permissions/operations.service';
import { debounceTime, tap, switchMap, finalize } from 'rxjs/operators';

@Component({
  selector: 'pplus-autocomplete-operations',
  templateUrl: './autocomplete-operations.component.html',
  styleUrls: ['./autocomplete-operations.component.scss']
})
export class AutocompleteOperationsComponent implements OnInit {
  operations: any;
  isLoading = false;
  formControl = new FormControl();
  selectedValue: Operation;

  constructor(private operationsService: OperationsService) { }

  ngOnInit() {
    this.selectedValue = null;
    this.initSearch();
  }

  initSearch() {
    this.formControl.valueChanges
      .pipe(
        debounceTime(500),
        tap(() => {
          this.operations = [];
          this.isLoading = true;
        }),
        switchMap(value => this.operationsService.searchByDescription(value)
          .pipe(
            finalize(() => {
              this.isLoading = false;
            }),
          )
        )
      )
      .subscribe(data => {
        this.operations = data;
      });
  }


  displayFn(value?: any) {
    return value ? value.description : '-';
  }


  optionSelected(value) {
    this.selectedValue = value;
  }

}
